import React from 'react';
import { t } from 'services/translation';
import styled from '@emotion/styled';

const LocationStyle = styled.div`
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 24px;
`;

export function Location({ location }) {
  const {
    shopping_center,
    address,
    city,
    state_province,
    zip_code,
    phone_number,
    places_address,
  } = location;
  return (
    <LocationStyle>
      {shopping_center && <strong>{shopping_center}</strong>}
      {address && <div>{address},</div>}
      {city && state_province && (
        <div>
          {city}, {state_province} {(zip_code || '').split('-')[0]}
        </div>
      )}
      <div>{phone_number}</div>
      <div>
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            places_address
          )}`}
          target="_blank"
          className="brand-color"
        >
          {t('VIEW_MAP')}
        </a>
      </div>
    </LocationStyle>
  );
}
